import { render, staticRenderFns } from "./HomeWishlistIT.vue?vue&type=template&id=3d8ea704&scoped=true"
import script from "./HomeWishlistIT.vue?vue&type=script&lang=js"
export * from "./HomeWishlistIT.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8ea704",
  null
  
)

export default component.exports